import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import withType from 'components/common/hoc/withType'
import { setPromotionData } from './actions'
import { SEARCH_PROMOTION_TYPE } from './constants'

const BOTSearchPromotion = () => null

export default compose(
  withType({ type: SEARCH_PROMOTION_TYPE }),
  connect(null, { setPromotionData }),
  lifecycle({
    componentDidMount() {
      this.props.setPromotionData(this.props)
    }
  })
)(BOTSearchPromotion)
